import api from './api';

const adminPost = (action, params = {}) =>
  api.post(`/admin/${action}`, { action, ...params }).then((res) => res.data);

// Dashboard
export const getDashboardStats = () => adminPost('get_dashboard_stats');

// Interns
export const listInterns = (filters = {}) => adminPost('list_interns', filters);
export const getIntern = (id) => adminPost('get_intern', { intern_id: id });
export const updateInternStatus = (id, status, reason = '') =>
  adminPost('update_intern_status', { intern_id: id, status, reason });
export const resetInternPassword = (id) =>
  adminPost('reset_intern_password', { intern_id: id });
export const clearInternCancellationFlag = (id, note = '') =>
  adminPost('clear_intern_cancellation_flag', { intern_id: id, note });
export const resetInternTest = (id, { note = '', alsoUnlockStatus = false } = {}) =>
  adminPost('reset_intern_test', { intern_id: id, note, also_unlock_status: alsoUnlockStatus });

// Video review — get current video state for the admin review panel,
// then approve or reject. Approve auto-waives bg check if the intern is in
// an active college cohort; otherwise routes to background check.
// Reject requires a reason (visible to intern in their rejection email).
export const getInternVideo = (internId) =>
  adminPost('get_intern_video', { intern_id: internId });

export const reviewInternVideo = (internId, decision, rejectionReason = '') =>
  adminPost('review_intern_video', {
    intern_id: internId,
    decision,
    rejection_reason: rejectionReason,
  });

// Bookings
export const listBookings = (filters = {}) => adminPost('list_bookings', filters);
export const getBooking = (id) => adminPost('get_booking', { booking_id: id });
export const getBookingHistory = (id) => adminPost('get_booking_history', { booking_id: id });
export const updateBooking = (id, updateType, data = {}) =>
  adminPost('update_booking', { booking_id: id, update_type: updateType, ...data });

// Assessments
export const listAssessments = (filters = {}) => adminPost('list_assessments', filters);
export const getAssessment = (id) => adminPost('get_assessment', { assessment_id: id });
export const assignAssessmentExpert = (assessmentId, expertId) =>
  adminPost('assign_assessment_expert', { assessment_id: assessmentId, expert_id: expertId });

// Payments
export const listPayments = () => adminPost('list_payments');
export const getRevenueSummary = () => adminPost('get_revenue_summary');
export const issueRefund = ({ bookingId, amountCents = null, reason = '' }) => {
  const body = { booking_id: bookingId, reason };
  if (amountCents != null) body.amount_cents = amountCents;
  return adminPost('issue_refund', body);
};

// Mentors (internally called "experts" in the backend / Cognito group — see
// project_cwc_mentor_expert_split memory for the naming convention).
export const listExperts = () => adminPost('list_experts');
export const inviteMentor = ({ email, name, specialization }) =>
  adminPost('invite_expert', { email, name, specialization });
export const listMentorClaims = () => adminPost('list_mentor_claims');
export const forceReleaseClaim = ({ assessmentId, reason }) =>
  adminPost('force_release_claim', { assessment_id: assessmentId, reason });

// Clients
export const listClients = () => adminPost('list_clients');

// Colleges
export const listColleges = () => adminPost('list_colleges');
export const createCollege = (data) => adminPost('create_college', data);
export const updateCollege = (id, data) =>
  adminPost('update_college', { college_id: id, ...data });

// Communications (bulk reminder emails) — Phase 2
// preview parses + buckets the CSV against the DB without sending anything.
// start_reminder_campaign fires the async sender Lambda; the campaign row
// updates as the sender progresses. list_reminder_campaigns powers the
// history table.
export const previewReminderCsv = (csvContent, { coolOffDays = 7, sampleLimit = 5, csvFilename = null, logUpload = true } = {}) =>
  adminPost('preview_reminder_csv', {
    csv_content: csvContent,
    cool_off_days: coolOffDays,
    sample_limit: sampleLimit,
    csv_filename: csvFilename,
    log_upload: logUpload,
  });

export const startReminderCampaign = ({
  audienceType,
  csvContent = null,
  csvFilename = null,
  bucketsToSend = null,
  coolOffDays = 7,
}) =>
  adminPost('start_reminder_campaign', {
    audience_type: audienceType,
    csv_content: csvContent,
    csv_filename: csvFilename,
    buckets_to_send: bucketsToSend,
    cool_off_days: coolOffDays,
  });

export const listReminderCampaigns = (limit = 20) =>
  adminPost('list_reminder_campaigns', { limit });
